import {
  EnvironmentProviders,
  inject,
  provideAppInitializer,
} from "@angular/core";
import { AuthService } from "./services/auth.service";
import { SessionExpiryService } from "./services/session-expiry.service";

/**
 * Watch for the session ending in a tab nobody is using, and open the
 * "Session Expired" dialog when it does (see SessionExpiryService). Follows
 * `AuthService.signedIn$`, so it starts the moment a session is in place and
 * stops on sign-out. No-op on the server.
 */
export function provideSessionExpiryWatch(): EnvironmentProviders {
  return provideAppInitializer(() => {
    inject(SessionExpiryService).start(inject(AuthService).signedIn$);
  });
}
